import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateQueries = () => {
  const queryClient = useQueryClient();

  const invalidateByPrefix = (prefix: string) =>
    queryClient.invalidateQueries({
      predicate: (query) => {
        const [key] = query.queryKey ?? [];
        return typeof key === 'string' && key.startsWith(prefix);
      },
    });

  const invalidateByKey = (queryKey: readonly unknown[]) =>
    queryClient.invalidateQueries({
      queryKey,
      exact: false,
    });

  return {
    invalidateByPrefix,
    invalidateByKey,
  };
};

